<template>
  <div>
    <ui-ask-danger ref="ask"/>
    <ui-modal v-model="showCreateCoupon">
      <template #title>
        <div class="mb-4">
          <h3 class="text-lg leading-6 font-medium text-gray-900">
            <span>Добавить купон</span>
          </h3>
          <p class="mt-1 text-sm leading-5 text-gray-500">
            Укажите предмет, количество часов, преподавателей и другие необходимые параметры.
          </p>
        </div>
      </template>


      <ui-form @submit.prevent.stop="pushCoupon">
        <div>
          <ui-form-item class="mt-4" label="Код для скидки" required
                        text-help="Рекомендуется не использовать пробелы и спец символы, код не чувствителен к регистру.">
            <ui-form-text :value="form.code.toUpperCase()" @input="form.code = $event.target.value.toUpperCase()"/>
          </ui-form-item>
          <ui-form-item class="mt-4" label="Сумма скидки" required>
            <ui-form-number v-model="form.discount"/>
          </ui-form-item>
        </div>
        <div class="mt-6 text-right">
          <ui-button color="white" class="mr-2" @click="showCreateCoupon = false">Отмена</ui-button>
          <ui-button color="green" type="submit">Добавить</ui-button>
        </div>
      </ui-form>
    </ui-modal>


    <ui-form class="bg-white space-y-6" store="event" @submit.prevent.stop="save">
      <div>
        <h3 class="text-lg leading-6 font-medium text-gray-900">Купоны на скидку</h3>
        <p class="mt-1 text-sm text-gray-500">
          Купоны на скидку можно использовать при оплате мероприятия (скидка применяется на каждого участника),
          на одно мероприятие можно применить только один купон.
        </p>


        <div class="mt-4">
          <div class="py-2 align-middle inline-block min-w-full">
            <div class="border-gray-200">
              <table class="table-simple">
                <thead>
                <tr>
                  <th scope="col">Купон</th>
                  <th scope="col">Скидка</th>
                  <th scope="col">Использовано</th>
                  <th scope="col"></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(coupon, index) in coupons" :key="index">
                  <td class="px-6 py-4 whitespace-nowrap">
                    <span>{{ coupon.code }}</span>
                  </td>

                  <td class="px-6 py-4 whitespace-nowrap">
                    <span>{{ coupon.discount }}</span>
                  </td>

                  <td class="px-6 py-4 whitespace-nowrap">
                    <span>{{ coupon.used }}</span>
                  </td>

                  <td class="text-right">

                    <ui-icon-trash-solid class="link-icon text-red-500 h-5 w-5 inline-flex"
                                         @click="remove(coupon.id)"/>


                  </td>
                </tr>

                </tbody>
              </table>
            </div>

          </div>
          <div class="relative mt-6">
            <div class="absolute inset-0 flex items-center" aria-hidden="true">
              <div class="w-full border-t border-gray-300"></div>
            </div>
            <div class="relative flex justify-center">
              <button type="button" @click="showCreateCoupon = true"
                      class="inline-flex items-center shadow-sm px-4 py-1.5 border border-gray-300 text-sm leading-5 font-medium rounded-full text-gray-700 bg-white hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500">
                <ui-icon-plus-sm-solid class="h-5 w-5"/>
                <span>Добавить купон</span>
              </button>
            </div>
          </div>
        </div>

      </div>


      <div class="py-3 text-right">
        <ui-button v-show="isModify" type="submit">Сохранить</ui-button>
      </div>
    </ui-form>


  </div>
</template>

<script>

import {mapActions, mapGetters} from "vuex";
import UiForm from "@/components/ui/form/UiForm";
import UiFormItem from "@/components/ui/form/UiFormItem";
import UiFormNumber from "@/components/ui/form/UiFormNumber";
import UiIconTrashSolid from "@/components/ui/icons/UiIconTrashSolid";
import UiIconPlusSmSolid from "@/components/ui/icons/UiIconPlusSmSolid";
import UiButton from "@/components/ui/button/UiButton";
import UiModal from "@/components/ui/modal/UiModal";
import UiFormText from "@/components/ui/form/UiFormText";
import UiAskDanger from "@/components/ui/ask/UiAskDanger";

export default {
  name: "EventEditPay",
  components: {
    UiAskDanger,
    UiFormText, UiModal, UiButton, UiIconPlusSmSolid, UiIconTrashSolid, UiFormNumber, UiFormItem, UiForm
  },
  data() {
    return {
      showCreateCoupon: false,
      form: {
        code: '',
        discount: 0,
      }
    }
  },
  computed: {
    ...mapGetters('event', ['isModify', "coupons"]),
  },
  methods: {
    ...mapActions('event', ['save', 'removeCoupon', 'postCoupon']),
    pushCoupon() {
      this.postCoupon(this.form).then(() => {
        this.showCreateCoupon = false;
        this.form = {code: '', discount: 0,}
      })
    },
    remove(id) {
      this.$refs.ask.show({title: 'Удалить купон'}).then(() => {
        this.removeCoupon(id);
      })

    },
  }
}
</script>

<style scoped>

</style>